<template>
  <div v-if="!loading">
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false">
      <strong
        v-if="lotProgram && panel === 'FICHE_LOT'"
        slot="breadcrumb">{{ lotProgram.name | cap }} - Création d'un lot</strong>
      <strong
        v-else-if="lotProgram && panel === 'FICHE_PARKING'"
        slot="breadcrumb">{{ lotProgram.name | cap }} - Création d'un parking</strong>
      <strong
        v-else-if="panel === 'IMPORT'"
        slot="breadcrumb">Création automatique de lots</strong>
    </page-nav-bar>
    <page-content
      :has-no-padd-on-act-on-desktop="false"
      :has-padd-left-on-act="true"
      :has-padd-right-on-act="true"
      :has-sticky-col-left="true"
      :set-main-col-class="'is-12 is-11-widescreen is-10-fullhd'">
      <div class="columns">
        <div class="column is-3 is-2-fullhd">
          <aside class="menu menu--admin">
            <ul class="menu-list has-background-white is-border">
              <li :class="{'is-active' : panel === 'FICHE_LOT'}">
                <a @click="panel = 'FICHE_LOT'">Fiche lot</a>
              </li>
              <li :class="{'is-active' : panel === 'IMPORT'}">
                <a @click="panel = 'IMPORT'">Import automatique</a>
              </li>
            </ul>
          </aside>
        </div>
        <div class="column">
          <div v-show="panel === 'FICHE_LOT'">
            <lot-create :source-lot-program="lotProgram"></lot-create>
          </div>
          <div v-show="panel === 'IMPORT'">
            <lots-import></lots-import>
          </div>
        </div>
      </div>
    </page-content>
  </div>
  <spinner-round
    :is-loading="loading"
    v-else></spinner-round>
</template>

<script>
import LotMixin from './LotMixin'

export default {
  name: 'LotParkingCreate',
  components: {
    LotCreate: () => import('./LotCreate'),
    LotsImport: () => import('./LotsImport')
  },
  mixins: [LotMixin],
  data () {
    return {
      loading: true,
      panel: 'FICHE_LOT'
    }
  },
  watch: {
    sourceLotProgram (v) {
      if (v) this.updateSources({ program: v })
    }
  },
  created () {
    if (this.$route.query.program) {
      this.getProgram(this.$route.query.program)
    }
  },
  mounted () {
    this.loading = false
  }
}
</script>
